<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="mountedHandler" :queryHandler="queryHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'
    import {getDefaultPageSizes} from '../../../src/app.conf'
    import {getMerchantBizParam} from '../asset/assetMain'
    import {getMerchtAssetNatureMap} from '../index'
    //
    import devcReqrApi from '../../api/devcReqr'
    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-adopted-device-list-select-group',
        props: {
            checkIds: {
                type: Array,
                default: null
            },
            radio: {
                type: Boolean,
                default: false
            },
            filter: {
                tyoe: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                confKey: 'swb-adopted-device-list-select-group',
                theTableHeight: 550,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: null,//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 300,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                contractKindMap: getEnumMap('contractKind', 'value2text'),
                devcCatList: []
            }
        },
        created: function () {
            let self = this;
            if (this.radio) {
                this.multiSelect = false;
                this.multiPageSelect = false;
                this.rowNoShow = true;
                this.rowNoFixed = true;
            }
            // 交易中是否展示资产相关信息
            getMerchantBizParam('display.asset.related.info.in.trading', function (result) {
                let showAssetInfo = Utils.isTrue(result);
                if (showAssetInfo) {
                    self.confKey = 'swb-adopted-device-list-select-group2';
                }
            });
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let initChecked = this.checkIds;
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, true);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            queryEventHanlder: function (itemCode, eventName, itemValue, filterItems) {
                if (itemCode == 'devcAssetNature' && eventName == 'change') {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let itemInfo = {
                        innerDevcCatId: {
                            value: null,
                            text: null
                        }
                    };
                    let dataList = [];
                    let devcCatList = this.devcCatList;
                    devcCatList.forEach(function (devcCat) {
                        if (devcCat.assetNature == itemValue || Utils.isNoB(itemValue)) {
                            dataList.push({
                                'value': devcCat.id,
                                'label': devcCat.name + '(' + devcCat.code + ')'
                            });
                        }
                    });
                    itemInfo.innerDevcCatId.dataList = dataList;
                    //
                    query_model_ctrl.updateFields(itemInfo);
                }
            },
            mountedHandler: function () {
                let self = this;
                // 资产属性
                getMerchtAssetNatureMap((merchtAssetNatureList) => {
                    if (merchtAssetNatureList.length > 0) {
                        let dataList = [{'value': null, 'label': '- 全部 -'}];
                        merchtAssetNatureList.forEach(function (item) {
                            let dataInfo = {};
                            dataInfo.value = item.value;
                            dataInfo.label = item.text;
                            dataList.push(dataInfo);
                        });
                        this.updateQueryModelField('devcAssetNature', dataList);
                    }
                });
                this.getDevcCatList(function (devcCatList) {
                    let dataList = [];
                    devcCatList.forEach(function (devcCat) {
                        dataList.push({
                            'value': devcCat.id,
                            'label': devcCat.name + '(' + devcCat.code + ')'
                        });
                    });
                    self.updateQueryModelField('innerDevcCatId', dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex) {
                        if (row.imageUrl != null && row.imageUrl != '') {
                            return '<a><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        } else {
                            let imgUrl = '\'/image/noimg.jpg\'';
                            return '<img style="height: 36px;width: 36px" v-resc-url="' + imgUrl + '"/>';
                        }
                    },
                    'devcAssetNature': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.assetNatureMap[row.devcAssetNature] + '</span>';
                    },
                    'contractKindId': function (row, colName, colValue, rowIndex) {
                        if (row.contractKindId == -1) {
                            return '<span>无合同</span>';
                        } else {
                            return '<span>' + self.contractKindMap[row.contractKindId] + '</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    if (this.dblClickHandler) {
                        this.dblClickHandler.call(this.$parent, row);
                    }
                }
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getDataList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            getDevcCatList(callback) {
                let self = this;
                shopDevcApi.getDevcCatList({
                    level: 3,
                    disabled: false,
                    auditState: 1,
                }, function (result) {
                    if (result.type == 'info') {
                        let srcDevcCatList = result.data;
                        let devcCatList = [];
                        srcDevcCatList.forEach(function (item) {
                            if (item.assetNature != 3) {
                                devcCatList.push(item);
                            }
                        });
                        self.devcCatList = devcCatList;
                        callback(devcCatList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDataList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems = Object.assign(filterItems, self.filter);
                filterItems.disabled = false;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                devcReqrApi.getAdoptedDeviceDevcDefPagedList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult() {
                let selectList = this.getTableSelection() || [];
                //
                let result = {};
                if (this.radio) {
                    if (Utils.isNoB(selectList)) {
                        result.type = 'warn';
                        result.message = '请选择！';
                    } else {
                        result.type = 'info';
                        result.data = [selectList];
                    }
                } else {
                    if (selectList.length <= 0) {
                        result.type = 'warn';
                        result.message = '请选择！';
                    } else {
                        result.type = 'info';
                        result.data = selectList;
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/GoodsInSelectGroup.vue